// extracted by mini-css-extract-plugin
export default {"tabList":"styles_tabList__SVXC2","tabContent":"styles_tabContent__w0wbv","tabListItem":"styles_tabListItem__qM1UW","tabListActive":"styles_tabListActive__FkoMC"};